import React, { useEffect, useRef, useState } from "react";
import InventoryTableComponent from "./InventoryTableComponent";
import SearchBox from "../CustomWidgets/SearchBox";
import {
  CloseOutlined,
  DownloadOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Image } from "antd";
import category from "../../assets/Inventory/spinner.svg";
import {
  DownloadInventoryAPI,
  GenerateExcelReport,
  InventoryCategoryFilter,
  InventorySearch,
  InventoryUpdateDetails,
  InventoryUpdateDetailsIncomplete,
  getInventoryEditResttriction,
  getInventoryOutLowHigh,
  getInventoryallcategories,
  getInventoryallproducts,
  getInventoryincompleteproducts,
  verifyInventoryPassword,
} from "../../API  Functions/InventoryFunctions";
import { debounce } from "@mui/material";
import { Alert } from "@material-tailwind/react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Select } from "antd";
import "../../styles.css";
import InCompletetable from "./InCompletetable";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ImportInventory from "../../modals/ImportInventory_Modal";
import showToast from "../../toastService";
import { toast } from "react-toastify";
import LoadingSpinner from "../Loading";
import ExportInventoryModal from "../../modals/ExportInventoryModal";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useLocation } from "react-router-dom";
import { checkPermission } from "../../Utils/permissionHelper";
import { getProductGroups } from "../../API  Functions/productGroupFunctions";
import ShimmerLoader from "../../loading";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import PasswordModal from "../../modals/PasswordModal";

const InventoryTableHeader = ({ dashData, selectedInventoryTile }) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const openChoice = location.state?.openChoice;
  const pageOption = location.state?.pageOption;

  const { Option } = Select;
  const [TableData, setTableData] = useState([]);
  const [IncompleteData, setIncompleteData] = useState([]);

  const [CategoryData, setCategoryData] = useState([]);
  const [groupData, setGroupData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [SelectedsubcategoryOptions, setSelectedsubcategoryOptions] = useState(
    [],
  );
  const [subcategory, setsubcategory] = useState([]);
  const [query, setquery] = useState("");
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [optionModal, setOpenOptionModal] = useState(openChoice ? true : false);
  const [currentLimit, setCurrentLimit] = useState(10); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const navigate = useNavigate();

  const masterStore = useSelector((state) => state.login.masterStore);
  const is_master_Store = useSelector(
    (state) => state?.login?.user?.result?.is_master_store,
  );
  const is_retailer = useSelector(
    (state) => state?.login?.user?.result?.is_retailer,
  );

  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const store_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );

  const products_count = useSelector(
    (state) => state?.dashData?.selectedDashData,
  );

  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store,
  );

  const [data] = useState([{ id: "11" }]);
  const [activeHeading, setActiveHeading] = useState(
    pageOption ? pageOption : 1,
  );
  const [headingWidth, setHeadingWidth] = useState(0);
  const activeHeadingRef = useRef(null);
  const [isImportInventoryOpen, setImportInventoryOpen] = useState(false);
  const [isImportInventoryOpen2, setImportInventoryOpen2] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const [selectedFields, setSelectedFields] = useState([]);
  const [showDiscounted, setShowDiscounted] = useState(false);
  const [showLoose, setShoWLoose] = useState(pageOption == 4 ? true : false);
  const [searchByShortCode, setSearchByShortCode] = useState(false);
  const [inventoryEditResriction, setInventoryEditResriction] = useState(false);
  const [masterPassword, setMasterPassword]= useState('');
  const [isShowCostPrice, setIsShowCostPrice] = useState(true);
  const [isEtaEnable, setIsEtaEnable] = useState(null);
  const [costingMethod, setCostingMethod] = useState("");

  const [openInventoryPasswordModal, setOpenInventoryPasswordModal] =
    useState(false);
  const [updateValues, setUpdateValues] = useState({});

  useEffect(() => {
    if (store_id) {
      getInventoryCategories();
      getInventoryGroups();
    }
  }, [store_id]);

  useEffect(() => {
    setDynamicWidth();
  }, [activeHeading, data]);
  const setDynamicWidth = () => {
    if (activeHeadingRef.current) {
      setHeadingWidth(activeHeadingRef.current.offsetWidth);
    }
  };

  useEffect(() => {
    setLoading(true);
    setSearchByShortCode(false);
    setTableLoading(true);
    // if (!is_retailer) {
    CheckUserAcessForInventory();
    // }
    setquery("");
    if (selectedInventoryTile === null) {
      // console.log("CKCKCC", );
      if (pageOption == 4) {
        console.log("NEWWWW");
        handleHeadingClick(4);
      } else {
        // console.log("OLLDDDD");

        getInventoryallproducts(
          user_id,
          store_id,
          selectedCategory,
          selectedGroup,
          "",
          10,
          0,
        ).then((res) => {
          // console.log("ALL PRODUCTS DTA", res?.result[0]?.response);

          setTableData(res?.result[0]?.response);
          setLoading(false);
          setTableLoading(false);
        });
      }
      // getInventoryKPI();
    } else {
      setLoading(true);
      setTableLoading(true);
      setActiveHeading(1);
      getInventoryOutLowHigh(
        user_id,
        store_id,
        selectedCategory,
        selectedGroup,
        selectedInventoryTile,
        "",
        10,
        0,
      ).then((res) => {
        setTableData(res?.result[0]?.response);
        setTableLoading(false);
        setLoading(false);
      });
    }
  }, [selectedInventoryTile]);

  useEffect(() => {
    if (location.state?.openChoice || location.state?.pageOption) {
      // Clear state after accessing it
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  const handleOptionChange = (selectedValue) => {
    setSelectedGroup(null);
    if (selectedValue === "All Categories") {
      setSelectedCategory(null); // Reset selected category
      setsubcategory([]); // Reset subcategory
      getInventoryKPI(); // Fetch all products
    } else {
      setSelectedCategory(selectedValue); // Set the selected category
      setsubcategory([]); // Reset subcategory

      if (selectedValue) {
        // Fetch products based on the selected category ID
        fetchProductsByCategory(false, selectedValue);

        // Update subcategories based on the selected category
        const cat = CategoryData.filter(
          (res) => res.category_id === selectedValue,
        )[0]?.sub_category_details;
        setsubcategory(cat || []); // Set subcategories or an empty array if none found
      }
    }
  };

  const handleGroupOptionChange = (selectedValue) => {
    setSelectedCategory(null);
    if (selectedValue === "All Groups") {
      setSelectedGroup(null); // Reset selected category
      getInventoryKPI(); // Fetch all products
    } else {
      setSelectedGroup(selectedValue); // Set the selected category

      if (selectedValue) {
        // Fetch products based on the selected category ID
        fetchProductsByCategory(selectedValue, false);
      }
    }
  };

  // New function to fetch products by selected category
  const fetchProductsByCategory = (
    groupId,
    categoryId,
    limit = 10,
    offset = 0,
  ) => {
    if (selectedInventoryTile) {
      setLoading(true);
      getInventoryOutLowHigh(
        user_id,
        store_id,
        categoryId,
        groupId,
        selectedInventoryTile,
        "",
        limit,
        offset,
      ).then((res) => {
        setTableData(res?.result[0]?.response);
        setLoading(false);
        setTableLoading(false);
      });
    } else {
      // Call the API with the selected category ID
      setLoading(true);
      getInventoryallproducts(
        user_id,
        store_id,
        categoryId,
        groupId,
        "",
        limit,
        offset,
        showDiscounted,
        showLoose,
      ).then((res) => {
        setTableData(res?.result[0]?.response);
        setLoading(false);
        setTableLoading(false);
      });
    }
  };

  const getInventoryKPI = (
    is_loose = showLoose,
    is_discounted = showDiscounted,
    limit = currentLimit,
    offset = currentOffset,
    selectedCategory = false,
    selectedGroup = false,
  ) => {
    setLoading(true);
    if (selectedInventoryTile) {
      getInventoryOutLowHigh(
        user_id,
        store_id,
        selectedCategory,
        selectedGroup,
        selectedInventoryTile,
        "",
        limit,
        offset,
      ).then((res) => {
        setTableData(res?.result[0]?.response);
        setLoading(false);
        setTableLoading(false);
      });
    } else {
      getInventoryallproducts(
        user_id,
        store_id,
        selectedCategory,
        selectedGroup,
        "",
        limit,
        offset,
        is_discounted,
        is_loose,
      ).then((res) => {
        // console.log("ALL PRODUCTS DTA", res?.result[0]?.response);

        setTableData(res?.result[0]?.response);
        setLoading(false);
        setTableLoading(false);
      });
    }
  };
  //Incomplete products
  const getInventoryIncompleteProducts = async (limit = 10, offset = 0) => {
    try {
      setLoading(true);

      const res = await getInventoryincompleteproducts(
        user_id,
        store_id,
        limit,
        offset,
      );

      setIncompleteData(res);
    } catch (error) {
      console.error("Error fetching incomplete inventory products:", error);
      // optionally show toast / message here
    } finally {
      setTableLoading(false);
      setLoading(false);
    }
  };

  //Inventory categories

  const getInventoryCategories = () => {
    getInventoryallcategories(user_id, store_id).then((res) => {
      // console.log("CATEGORY RESPONSE --->", res);

      setCategoryData(res);
    });
  };

  const getInventoryGroups = () => {
    let payload = {
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      company_id: store_id,
      user_id: user_id,
      offset: 0,
      limit: 1000,
    };
    getProductGroups(payload).then((res1) => {
      // console.log("CATEGORY RESPONSE --->", res);
      if (res1?.result[0]?.status_code === 200) {
        setGroupData(res1?.result[0]?.product_groups);
      } else {
        setGroupData([]);
      }
    });
  };

  const handleHeadingClick = (headingNumber) => {
    setCurrentLimit(10);
    setCurrentOffset(0);
    setquery("");
    setSelectedOptions([]);
    setTableLoading(true);
    setSelectedsubcategoryOptions([]);
    switch (headingNumber) {
      case 1:
        setShowDiscounted(false);
        setShoWLoose(false);
        getInventoryKPI(false, false, 10, 0, selectedCategory, selectedGroup);
        break; // Add break statement to prevent falling through to the next case
      case 2:
        setShowDiscounted(false);
        setShoWLoose(false);
        getInventoryIncompleteProducts();
        break; // Add break statement to prevent falling through to the default case
      case 3:
        getInventoryKPI(false, true, 10, 0, selectedCategory, selectedGroup);
        setShowDiscounted(true);
        setShoWLoose(false);
        break;
      case 4:
        getInventoryKPI(true, false, 10, 0, selectedCategory, selectedGroup);
        setShowDiscounted(false);
        setShoWLoose(true);
        break;
      default:
        // Handle default case if needed
        break;
    }
    setActiveHeading(headingNumber);

    // getData(1);
    // getData(id[headingNumber - 1].id);
  };

  const debouncedSearch = debounce((value) => {
    setLoading(true);

    const productName = value === "" ? "" : value; // Set product_name as empty string if no value
    const limit = 10; // Set limit
    const offset = 0; // Set offset

    if (value === "") {
      getInventoryKPI();
    } else {
      if (selectedInventoryTile) {
        getInventoryOutLowHigh(
          user_id,
          store_id,
          false,
          false,
          selectedInventoryTile,
          productName,
          limit,
          offset,
        ).then((res) => {
          if (res?.result[0]?.response) {
            setTableData(res.result[0].response);
            setSelectedCategory(null);
            setSelectedGroup(null);
            setLoading(false);
            setTableLoading(false);
          }
        });
      } else {
        getInventoryallproducts(
          user_id,
          store_id,
          false,
          false,
          productName,
          limit,
          offset,
        ).then((res) => {
          if (res?.result[0]?.response) {
            setTableData(res.result[0].response);
            setSelectedCategory(null);
            setSelectedGroup(null);
            setLoading(false);
            setTableLoading(false);
          }
        });
      }
    }
  }, 1000);

  const debouncedSearchbyCode = debounce(async (value) => {
    setLoading(true);

    const productName = value === "" ? "" : value; // Set product_name as empty string if no value
    const limit = 10; // Set limit
    const offset = 0; // Set offset

    if (value === "") {
      getInventoryKPI();
    } else {
      let payload = {
        lang: i18n.language == "ar" ? "ar_001" : "en_US",
        short_code: productName,
        type: selectedInventoryTile ? selectedInventoryTile : "all", //required // all or low or high or out
        company_id: store_id,
      };
      const response = await axiosInstance.post(
        URLS.GET_STOCK_BY_CODE,
        payload,
      );
      if (response?.data?.result[0]?.response) {
        setTableData(response?.data?.result[0].response);
        setSelectedCategory(null);
        setSelectedGroup(null);
        setLoading(false);
        setTableLoading(false);
      }
    }
  }, 1000);

  const CheckUserAcessForInventory = async () => {
    try {
      const res = await getInventoryEditResttriction(
        masterStore?.user_id || user_id,
      );
      if (res?.result?.status_code == 200) {
        setInventoryEditResriction(res?.result?.restrict_cost_price);
        setMasterPassword(res?.result?.master_password);
        setIsShowCostPrice(res?.result?.is_show_cost_price)
          setIsEtaEnable(res?.result?.is_eta_enabled);
        setCostingMethod(res?.result?.costing_method);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const handlePasswordConfirm = async (password) => {
    try {
      // const res = await verifyInventoryPassword(user_id, password);
      
      if (password === masterPassword) {
        setOpenInventoryPasswordModal(false);
        handledetailUpdate(updateValues);
        setUpdateValues({});
      } else {
        toast.error(t("Invalid Password"));
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const handledetailUpdate = async (val) => {
    let duplicateBarcodeShown = false;
    let costPriceErrorShown = false;
    let inventoryUpdatedShown = false;
    let duplicateShortCode = false;

    for (const item of val) {
      try {
        const response = await InventoryUpdateDetails(item);
        const result = response?.result?.[0];

        if (
          result?.status === "Duplicate Machine Barcode" &&
          result?.status_code === 400 &&
          !duplicateBarcodeShown
        ) {
          toast.error("Duplicate Product Code");
          duplicateBarcodeShown = true;
        }

        if (
          result?.status ===
            "Entered short code is already linked with another product." &&
          result?.status_code === 400 &&
          !duplicateShortCode
        ) {
          toast.error(
            t(
              "Product Short Code Already Exists. Please Use a Different Short Code.",
            ),
          );
          duplicateShortCode = true;
        }

        if (
          result?.status === "Cost Price cannot be greater than  Sale Price" &&
          result?.status_code === 400 &&
          !costPriceErrorShown
        ) {
          toast.error(t("Cost Price cannot be greater than Sale Price"));
          costPriceErrorShown = true;
        }

        if (result?.status === "Inventory Updated" && !inventoryUpdatedShown) {
          toast.success(t("Inventory Updated"));
          inventoryUpdatedShown = true;
        }
      } catch (error) {
        console.error("Error updating item:", error);
      }
    }

    // Refresh after loop finishes
    if (activeHeading === 1) {
      getInventoryKPI();
    } else {
      getInventoryIncompleteProducts();
    }
  };

  const handleIncompletedetailUpdate = async (val) => {
    // console.log("VALLLL", val);

    // Iterate over each item in the val array
    InventoryUpdateDetailsIncomplete(val, store_id).then((res) => {
      // console.log("res", res, activeHeading);
      res?.result[0]?.status == "Sales/Cost Price Updated" &&
        (activeHeading == 2
          ? getInventoryIncompleteProducts()
          : getInventoryIncompleteProducts());
    });
  };

  // const handleinventoryreportdownload = (val) => {
  //   // console.log(val);
  //   GenerateExcelReport(user_id, store_id, val).then((res) => console.log(res));
  // };
  useEffect(() => {
    setDynamicWidth();
  }, [activeHeading, data]);

  const components = [
    <InventoryTableComponent
      additionalData={TableData}
      isShowCostPrice={isShowCostPrice}
      costingMethod={costingMethod}
      setAdditionalData={(val) => {
        const isPriceChanged = val.some((item) => {
          const oldItem = TableData.find(
            (row) => row.quant_id === item.quant_id,
          );

          if (!oldItem) return false;
          console.log(item);

          return (
            Number(item.new_quantity) !== Number(oldItem.system_quantity) ||
            Number(item.new_price) !== Number(oldItem.current_price) ||
            Number(item.new_cost_price) !== Number(oldItem.current_cost_price)
          );
        });

        if (inventoryEditResriction && isPriceChanged) {
          setUpdateValues(val);
          setOpenInventoryPasswordModal(true);
        } else {
          handledetailUpdate(val);
        }
      }}
      pagination={(values) => {
        setCurrentLimit(values.limit);
        setCurrentOffset(values.offset);
        getInventoryKPI(
          showLoose,
          showDiscounted,
          values.limit,
          values.offset,
          selectedCategory,
          selectedGroup,
        );
      }}
      passordModal={openInventoryPasswordModal}
      allGroups={groupData}
    />,

    <InCompletetable
      additionalData={IncompleteData}
      setAdditionalData={(val) => {
        setUpdateValues(val);
        handleIncompletedetailUpdate(val);
      }}
      pagination={(values) => {
        setCurrentLimit(values.limit);
        setCurrentOffset(values.offset);
        setLoading(true);
        getInventoryIncompleteProducts(values.limit, values.offset);
      }}
    />,
    <InventoryTableComponent
      additionalData={TableData}
      costingMethod={costingMethod}
      isShowCostPrice={isShowCostPrice}
      setAdditionalData={(val) => {
        const isPriceChanged = val.some((item) => {
          const oldItem = TableData.find(
            (row) => row.quant_id === item.quant_id,
          );

          if (!oldItem) return false;

          return (
            Number(item.new_quantity) !== Number(oldItem.system_quantity) ||
            Number(item.new_price) !== Number(oldItem.current_price) ||
            Number(item.new_cost_price) !== Number(oldItem.current_cost_price)
          );
        });

        if (inventoryEditResriction && isPriceChanged) {
          setUpdateValues(val);
          setOpenInventoryPasswordModal(true);
        } else {
          handledetailUpdate(val);
        }
      }}
      pagination={(values) => {
        setCurrentLimit(values.limit);
        setCurrentOffset(values.offset);
        getInventoryKPI(
          showLoose,
          showDiscounted,
          values.limit,
          values.offset,
          selectedCategory,
          selectedGroup,
        );
      }}
      passordModal={openInventoryPasswordModal}
      allGroups={groupData}
    />,
    <InventoryTableComponent
      additionalData={TableData}
      costingMethod={costingMethod}
      isShowCostPrice={isShowCostPrice}
      setAdditionalData={(val) => {
        const isPriceChanged = val.some((item) => {
          const oldItem = TableData.find(
            (row) => row.quant_id === item.quant_id,
          );

          if (!oldItem) return false;

          return (
            Number(item.new_quantity) !== Number(oldItem.system_quantity) ||
            Number(item.new_price) !== Number(oldItem.current_price) ||
            Number(item.new_cost_price) !== Number(oldItem.current_cost_price)
          );
        });

        if (inventoryEditResriction && isPriceChanged) {
          setUpdateValues(val);
          setOpenInventoryPasswordModal(true);
        } else {
          handledetailUpdate(val);
        }
      }}
      pagination={(values) => {
        setCurrentLimit(values.limit);
        setCurrentOffset(values.offset);
        getInventoryKPI(
          showLoose,
          showDiscounted,
          values.limit,
          values.offset,
          selectedCategory,
          selectedGroup,
        );
      }}
      passordModal={openInventoryPasswordModal}
      allGroups={groupData}
    />,
  ];

  const handleImportInventory = () => {
    setImportInventoryOpen(true);
  };

  const closeInventory = () => {
    getInventoryKPI();
    setImportInventoryOpen(false);
    setImportInventoryOpen2(false);
  };

  const exportFields = [
    { key: "barcode", label: t("Barcode") },
    { key: "product_name", label: t("Product Name") },
    { key: "product_name2", label: t("Custom Product Name") },
    {
      key: "quantity",
      label: t("Quantity"),
      children: [
        { key: "all", label: t("All") },
        { key: "is_lte_zero", label: t("Less than 1") },
        { key: "is_gt_zero", label: t("Greater than equal to 1") },
      ],
    },
    { key: "sale_price", label: t("Sale Price") },
    { key: "cost_price", label: t("Cost Price") },
    { key: "categ_name", label: t("Category Name") },
    { key: "sub_categ_name", label: t("Sub Category Name") },
    { key: "group_name", label: t("Group Name"), isDynamic: true },
    ...(isEtaEnable ? [{ key: "vat_details", label: t("Product Taxes") }] : []),
    { key: "machine_barcode", label: t("Weighing Scale Product Code") },
    { key: "product_shortcut", label: t("Product Short Code") },
    { key: "secondary_barcode", label: t("Secondary Barcode") },

    // 👉 Show only when isEtaEnable === true
  ];

  const handleExport = async (
    selectedFields,
    selectedStores,
    quantityFilter,
    selectedGroupIds,
  ) => {
    setExportModalOpen(false);
    const exportToastId = toast.loading(t("Exporting inventory..."));

    try {
      const payload = {
        user_id,
        company_id: store_id,
        sub_company_ids: selectedStores || [],
        lang: i18n.language === "ar" ? "ar_001" : "en_US",
        qty_filter: quantityFilter,
        group_ids: selectedGroupIds,
      };

      const allData = await DownloadInventoryAPI(payload);
      const storeDataList = allData?.result?.[0]?.response ?? [];

      if (!Array.isArray(storeDataList)) {
        toast.update(exportToastId, {
          render: t("Invalid data received."),
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
        return;
      }

      // 🔹 Map main keys to labels
      const keyToLabelMap = exportFields.reduce((acc, { key, label }) => {
        acc[key] = label;
        return acc;
      }, {});

      // 🔹 Product Taxes sub-column labels
      const taxColumnLabels = {
        tax_name: t("Tax Name"),
        tax_rate_percent: t("Tax Rate (%)"),
        is_tax_price_inclusive: t("Tax Price Inclusive"),
      };

      const workbook = XLSX.utils.book_new();
      const mergedData = [];

      // 🔹 Build rows
      storeDataList.forEach((store) => {
        const storeName = store.store_name || "Store";

        store.products.forEach((item) => {
          const row = {};

          selectedFields.forEach((key) => {
            // ✅ PRODUCT TAXES
            if (key === "vat_details") {
              row[taxColumnLabels.tax_name] = item?.vat_details?.tax_name || "";

              row[taxColumnLabels.tax_rate_percent] =
                item?.vat_details?.tax_rate_percent ?? "";

              row[taxColumnLabels.is_tax_price_inclusive] = item?.vat_details
                ?.is_tax_price_inclusive
                ? t("Yes")
                : t("No");

              return;
            }

            // ✅ NORMAL FIELDS
            if (key in item) {
              row[keyToLabelMap[key]] = item[key];
            }
          });

          // 👈 Store Name last column
          row[t("Store Name")] = storeName;

          mergedData.push(row);
        });
      });

      // 🔹 Create worksheet
      const worksheet = XLSX.utils.json_to_sheet(mergedData, {
        header: [
          ...selectedFields.flatMap((key) => {
            if (key === "vat_details") {
              return [
                taxColumnLabels.tax_name,
                taxColumnLabels.tax_rate_percent,
                taxColumnLabels.is_tax_price_inclusive,
              ];
            }
            return keyToLabelMap[key];
          }),
          t("Store Name"),
        ],
      });

      XLSX.utils.book_append_sheet(workbook, worksheet, "Inventory");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const dataBlob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(dataBlob, "InventoryExport.xlsx");

      toast.update(exportToastId, {
        render: t("Export completed successfully"),
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });
    } catch (error) {
      console.error("Export failed:", error);

      toast.update(exportToastId, {
        render: t("Export failed. Please try again."),
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 50,
    },
    container: {
      width: "70%",
      padding: "30px",
      borderRadius: "18px",
      margin: "0 auto",
      backgroundColor: "#ffffff",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 50,
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    title: {
      fontSize: "20px",
      fontWeight: "bold",
      textAlign: "left",
      marginBottom: "10px",
    },
    cancelIcon: {
      cursor: "pointer",
    },
    description: {
      textAlign: "left",
      fontSize: "16px",
      color: "#272728",
      marginTop: "10px",
    },
    input: {
      width: "100%",
      padding: "10px",
      borderRadius: "12px",
      border: "1px solid #CCCCCC",
      marginBottom: "20px",
      boxSizing: "border-box",
    },
    buttonContainer: {
      display: "flex",
      justifyContent: "center",
    },
    button: {
      width: "180px",
      height: "45px",
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      marginRight: "10px",
      transition: "opacity 0.3s", // Smooth transition for opacity change
    },
    confirmButton: {
      backgroundColor: "primaryBlue",
      color: "#FFFFFF",
    },
    cancelButton: {
      backgroundColor: "#CCCCCC",
      color: "#000000",
    },
  };

  const closePasswordModal = () => {
    setUpdateValues({});
    setOpenInventoryPasswordModal(false);
  };

  return (
    <>
      {loading && <LoadingSpinner />}
      {openInventoryPasswordModal === true && (
        <PasswordModal
          onCancel={closePasswordModal}
          onConfirm={handlePasswordConfirm}
        />
      )}
      {optionModal && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black bg-opacity-30 backdrop-blur-sm z-40"
            onClick={() => setOpenOptionModal(false)}
          ></div>

          {/* Modal Container */}
          <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-xl shadow-2xl z-50 w-full max-w-xl p-8">
            {/* Header */}
            <div className="flex justify-between items-center mb-6">
              <h3 className="text-2xl font-semibold text-gray-800">
                {t("Add Product")}
              </h3>
              <button
                onClick={() => setOpenOptionModal(false)}
                className="text-gray-500 hover:text-gray-700 transition-colors"
              >
                <CloseOutlined className="text-2xl" />
              </button>
            </div>

            {/* Action Buttons in Column */}
            <div className="flex flex-col gap-6">
              <div>
                <button
                  type="button"
                  onClick={() => {
                    setOpenOptionModal(false);
                    setImportInventoryOpen2(true);
                  }}
                  className="w-full px-6 py-4 font-semibold rounded-lg border-2 border-primaryBlue text-primaryBlue hover:bg-gray-50 bg-white transition-colors flex items-center justify-center gap-3 text-lg"
                >
                  <UploadOutlined />
                  {t("Bulk Upload")}
                </button>
                <div className="text-sm text-gray-500 mt-1">
                  {t("(If you have the data with barcode)")}
                </div>
              </div>

              <div className="border-t border-gray-200 " />

              <button
                onClick={() => navigate("/inventory/InventoryOnboard")}
                className="w-full px-6 py-4 rounded-lg font-semibold border-2 border-primaryBlue text-primaryBlue hover:bg-gray-50 bg-white transition-colors flex items-center justify-center gap-3 text-lg"
              >
                <PlusOutlined />
                {t("Add Manually")}
              </button>
            </div>

            {/* Footer */}
            <div className="mt-8 pt-4 border-t border-gray-100 text-sm text-gray-500 text-center">
              {t("Choose an option to add products to your inventory")}
            </div>
          </div>
        </>
      )}

      {isImportInventoryOpen && (
        <ImportInventory
          isOpen={isImportInventoryOpen}
          onClose={() => closeInventory()}
        />
      )}
      {isImportInventoryOpen2 && (
        <ImportInventory
          isAdd={true}
          isOpen={isImportInventoryOpen2}
          onClose={() => closeInventory()}
        />
      )}

      {exportModalOpen && (
        <ExportInventoryModal
          isOpen={exportModalOpen}
          onClose={() => setExportModalOpen(false)}
          onExport={(fields, stores, quantityFilter, selectedGroupIds) =>
            handleExport(fields, stores, quantityFilter, selectedGroupIds)
          }
          exportFields={exportFields}
          masterStore={masterStore}
          is_master_Store={is_master_Store}
          groupData={groupData}
          isEtaEnable={isEtaEnable}
        />
      )}
      {activeHeading !== 2 && (
        <div className="mx-2 mt-2 flex flex-col gap-3 lg:mx-3 lg:flex-row lg:items-start lg:justify-between">
          <div className="flex justify-between md:justify-normal w-full md:w-[50%] flex-wrap items-center gap-2">
            <div className="w-[66%] md:w-[52%]">
              <SearchBox
                showBarcode={true}
                searchResult={(values) => {
                  setquery(values);

                  if (searchByShortCode) {
                    debouncedSearchbyCode(values);
                  } else if (values.length >= 2 || values.length === 0) {
                    debouncedSearch(values);
                  }
                }}
                placeholder={
                  searchByShortCode
                    ? t("Search Short Code")
                    : t("Search Products")
                }
                width={"100%"}
                value={query}
              />
            </div>
            <button
              type="button"
              onClick={() => {
                if (searchByShortCode) {
                  debouncedSearch("");
                }
                setSearchByShortCode(!searchByShortCode);
              }}
              className={`h-[40px] w-auto rounded-md border px-2 text-sm whitespace-nowrap md:w-auto
    ${
      searchByShortCode
        ? "bg-blue-100 border-primaryBlue text-primaryBlue"
        : "bg-white border-gray-300 text-gray-700"
    }`}
            >
              {t("Search Code")}
            </button>
            <Select
              className="overflow-hidden"
              style={{
                width: 130,
                minWidth: 130,
                height: 40,
              }}
              placeholder={t("Select Group")}
              value={selectedGroup || t("All Groups")} // Set default value to "All Categories"
              onChange={handleGroupOptionChange} // Keep this as is
            >
              <Option value="All Groups">{t("All Groups")}</Option>{" "}
              {/* Add All Categories option */}
              {Object.values(groupData)?.map((option) => (
                <Option key={option.id} value={option.id}>
                  {i18n.language == "ar" ? option.name_ar : option.name}
                </Option>
              ))}
            </Select>
          </div>
          {!selectedInventoryTile && (
            <div className="flex w-full flex-nowrap gap-1 md:gap-2 overflow-x-auto lg:w-auto lg:gap-3">
              <button
                className="flex h-10 w-64 items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white lg:w-28"
                onClick={() => {
                  if (allStores) {
                    setExportModalOpen(true);
                  } else {
                    if (checkPermission("/inventory", isGinne)) {
                      setExportModalOpen(true);
                    }
                  }
                }}
              >
                <DownloadOutlined
                  style={{ fontSize: "1.2em", MozMarginStart: -10 }}
                />

                <span>{t("Export")}</span>
              </button>

              <button
                className="flex h-10  w-64 items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white lg:w-28"
                // onClick={handleImportInventory}
                onClick={() => {
                  if (checkPermission("/inventory", isGinne)) {
                    handleImportInventory();
                  }
                }}
              >
                <UploadOutlined
                  style={{ fontSize: "1.2em", MozMarginStart: -10 }}
                />
                <span> {t("Import")}</span>
              </button>

              <Link
                to="/inventory/InventoryOnboard"
                className="w-full lg:w-auto"
              >
                <button className="flex h-10 w-full items-center justify-center gap-2 rounded-lg bg-primaryBlue text-sm font-semibold text-white lg:w-36">
                  <PlusOutlined
                    style={{ fontSize: "1.2em", MozMarginStart: -10 }}
                  />
                  <span> {t("add_product")}</span>
                </button>
              </Link>
            </div>
          )}
        </div>
      )}
      {data.map((val, index) => (
        <div
          key={val.id}
          className="mx-2 mb-[0.62rem] mt-4 flex flex-wrap gap-x-3 md:gap-x-5 gap-y-2 text-sm font-semibold text-[#999999] sm:text-base lg:mx-3 lg:gap-7"
        >
          {[1, 2, 4].map((headingNumber) => {
            if (
              selectedInventoryTile &&
              (headingNumber === 2 || headingNumber === 4)
            )
              return null;

            const badgeColor =
              headingNumber === activeHeading && headingNumber === 1
                ? "#FCC71D"
                : "#E7E7E7";

            let headingText = t("all_products");
            if (selectedInventoryTile === "out") {
              headingText = t("out_of_stock");
            } else if (selectedInventoryTile === "low") {
              headingText = t("low_on_inventory");
            } else if (selectedInventoryTile === "high") {
              headingText = t("high_on_inventory");
            }

            return (
              <h1
                key={headingNumber}
                ref={headingNumber === activeHeading ? activeHeadingRef : null}
                className={`g-${headingNumber}`}
                onClick={() => handleHeadingClick(headingNumber)}
                style={{
                  fontWeight:
                    headingNumber === activeHeading ? "600" : "#999999",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <span
                  className="font-semibold"
                  style={{
                    color:
                      headingNumber === activeHeading ? "#272728" : "#999999",
                  }}
                >
                  {headingNumber === 1 && headingText}
                  {headingNumber === 2 && t("incomplete")}
                  {/* {headingNumber === 3 && t("Discounted")} */}
                  {headingNumber === 4 && t("Loose Items")}
                </span>

                {headingNumber === activeHeading && (
                  <div
                    style={{
                      width: "6px",
                      height: "6px",
                      borderRadius: "50%",
                      backgroundColor: "#FCC71D",
                      marginLeft: i18n.language === "ar" ? "0" : "10px",
                      marginRight: i18n.language === "ar" ? "10px" : "0",
                    }}
                  />
                )}

                <div
                  style={{
                    borderRadius: "10px",
                    maxHeight: "23px",
                    backgroundColor: badgeColor,
                    padding: "0px 7px",
                    marginLeft: i18n.language === "ar" ? "0" : "5px",
                    marginRight: i18n.language === "ar" ? "5px" : "0",
                    display:
                      headingNumber === 1 && activeHeading === headingNumber
                        ? "block"
                        : "none",
                  }}
                >
                  <span style={{ color: "#000000" }}>
                    {headingNumber === 2
                      ? IncompleteData?.length
                      : selectedInventoryTile === "out"
                        ? products_count?.stock_out || 0
                        : selectedInventoryTile === "low"
                          ? products_count?.low_stock || 0
                          : selectedInventoryTile === "high"
                            ? products_count?.high_stock || 0
                            : products_count?.no_of_product_added || 0}
                  </span>
                </div>
              </h1>
            );
          })}
        </div>
      ))}
      <hr className="mx-2 lg:mx-3" />

      <div className="flex items-center justify-center gap-x-2 px-2 sm:pl-3">
        {tableLoading ? (
          <ShimmerLoader />
        ) : (
          <>{components[activeHeading - 1]}</>
        )}
      </div>
    </>
  );
};

export default InventoryTableHeader;
